export default __webpack_public_path__ + "static/media/pause.72e3c540.svg";